import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CFM_BLUEBERRY, CFM_STONE } from 'constants/Colors';
import './styles.scss';

const iconColors = {
    info: CFM_BLUEBERRY,
};

class Alert extends PureComponent {
    renderIcon = () => {
        const { icon: Icon, type } = this.props;
        if (typeof Icon === 'string' || typeof Icon === 'function') {
            return <Icon color={iconColors[type] || CFM_STONE} />;
        }
        if (typeof Icon === 'object') {
            return Icon;
        }
        return null;
    };

    render() {
        const { dataTest = '', icon, type, text = '' } = this.props;
        const alertClass = `alert alert-${type}`;

        return (
            <div className={alertClass} role="alert" data-test={dataTest}>
                {icon && <div className="alert-icon">{this.renderIcon()}</div>}
                <div className="alert-text">{text}</div>
            </div>
        );
    }
}

Alert.propTypes = {
    /** Type of alert. Values: success, danger, warning, info */
    type: PropTypes.string.isRequired,
    /** Text of the alert */
    text: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    dataTest: PropTypes.string,
};

export default Alert;
